import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Tooltip } from '@mui/material';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import { packetStatusOptions } from '../_Utils/AppDocuCommon';
import EditPacketDialog from '../Packet_Components/EditPacketDialog';

export default class DialogPacketDetails extends React.Component {
  state = { loading: false, pkg: null,  itemDataToEdit: null };

  async loadData() {
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.getPacket(this.props.packageId);
      const pkg = res.data.package || null;
      this.setState({ pkg, loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  }
  
  async componentDidUpdate(prevProps) {
    if (this.props.packageId && this.props.packageId !== prevProps.packageId) {
      await this.loadData();
    }
  }

  renderValue = value => value ? (
    <Typography variant="body1" sx={{ color: 'grey.900' }}>{value}</Typography>
  ) : (
    <Typography variant="body2" sx={{ color: '#bdbdbd', textTransform: 'uppercase' }}>undefined</Typography>
  );

  renderStatus = (status) => {
    if (!status) return this.renderValue();
    const found = packetStatusOptions.find(opt => opt.name === status);
    if (!found) return this.renderValue(status);
    const bg = found.color || '#888';
    const tip = found.comment || found.name;
    return (
      <Tooltip 
        title={tip} 
        arrow 
        PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -10] } }] }}
        componentsProps={{ tooltip: { sx: { bgcolor: bg, color: '#fff', '& .MuiTooltip-arrow': { color: bg } } } }}>
        <span style={{ 
          display: 'inline-block', 
          padding: '2px 10px', 
          borderRadius: 6, 
          background: bg, 
          color: '#fff', 
          fontWeight: 700, 
          fontSize: 13 
        }}>{found.name}</span>
      </Tooltip>
    );
  }

  render() {
    const { pkg, loading } = this.state;
    const { open, onClose } = this.props;
    return (
      <>
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Packet Details</DialogTitle>
          <DialogContent>
            {loading && <Typography>Loading...</Typography>}
            {pkg && (
              <Stack spacing={2}>
                <Typography variant="h5" sx={{ fontWeight: 700, color: 'primary.main' }}>{pkg.name}</Typography>
                {/* <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Description</Typography>
                  {this.renderValue(pkg.description)}
                </div> */}
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Com Brand</Typography>
                  {this.renderValue(pkg.com_brand)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>ECU Type</Typography>
                  {this.renderValue(pkg.ecu_type)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Kit Code</Typography>
                  {this.renderValue(pkg.kit_code)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Rail Code</Typography>
                  {this.renderValue(pkg.rail_code)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Rail2 Code (Boxer)</Typography>
                  {this.renderValue(pkg.rail2_code)}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Other Accessories</Typography>
                  {(pkg.other_accessories || '').split(/\r?\n|,/).filter(Boolean).length === 0 ? (
                    this.renderValue()
                  ) : (   
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {(pkg.other_accessories || '').split(/\r?\n|,/).filter(Boolean).map((acc, i) => (
                        <li key={i} style={{ color: '#222', fontSize: 15 }}>{acc.trim()}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <div>
                  <Typography variant="caption" sx={{ color: 'grey.700' }}>Status:{' '}</Typography>
                  {this.renderStatus(pkg.status)}
                </div>
              </Stack>
            )}
          </DialogContent>
          <DialogActions>
            {this.props.showEdit && pkg && (
              <Button onClick={() => this.setState({ itemDataToEdit: pkg })}>Edit</Button>
            )}
            <Button onClick={onClose}>Close</Button>
          </DialogActions>
        </Dialog>
        <EditPacketDialog
          itemId={this.state.itemDataToEdit ? this.state.itemDataToEdit.id : null}
          onClose={() => this.setState({ itemDataToEdit: null })}
          onItemsChange={() => this.loadData()}
          packageCodes={this.props.packageCodes}
        />        
      </>
    );
  }
}
